import React from 'react'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next';
import lang from '../utils/translations';
import { RiCopyrightLine } from 'react-icons/ri';

function LastFooter() {
  return (
    <div className="container-fluid text-white user-select-none" style={{backgroundColor:"#010a17"}}>
      <div className="d-flex justify-content-between flex-wrap align-items-center all-text-center">

          <div className="d-flex all-text-center flex-wrap py-2">
            <RiCopyrightLine size={20} className="text-white"/>
            <div className="fs-6 fw-bold ms-1 text-center no-white-space">
              {new Date().getFullYear()} Mudacumura Publishing House Ltd.
            </div>
            <div className="fs-6 fw-bold ms-1 text-center no-white-space">All Rights Reserved</div>
          </div>

          <div className="d-flex align-items-center flex-nowrap all-text-center py-2">
            <Link to='/privacy' className="fw-bold fs-6 me-5">{lang.t('Privacy')}</Link>
            <Link to='/terms' className="fw-bold fs-6 no-white-space">{lang.t('Terms of use')}</Link>
          </div>

      </div>
    </div>
  )
}

export default withTranslation()(LastFooter);
